import { useQuery } from '@tanstack/react-query';
import { GetUserAdminResponse } from '@blisspointmedia/bpm-types/dist/UserAdmin';
import { Role } from '@blisspointmedia/bpm-types/dist/Users';
import { awaitJSON, UsersLambdaFetch } from '../../utils/fetch-utils';

export interface ReviewerOption {
  label: string;
  value: string;
}

export interface ReviewerOptions {
  external: ReviewerOption[];
  internal: ReviewerOption[];
}

const toOption = (user: { email: string; full_name: string }): ReviewerOption => ({
  label: user.full_name ? `${user.full_name} (${user.email})` : user.email,
  value: user.email.toLowerCase()
});

// Reviewer pickers fed by the user admin list: Tinuiti staff for internal reviewers, and this client's
// users for external ones.
export const useReviewerOptions = (company: string) =>
  useQuery({
    queryKey: ['copytiger-reviewer-options', company],
    queryFn: async (): Promise<ReviewerOptions> => {
      const { users } = await awaitJSON<GetUserAdminResponse>(
        await UsersLambdaFetch('/userAdmin/getUsers')
      );
      return {
        external: users
          .filter(user => user.role > Role.INTERNAL && user.companies?.includes(company))
          .map(toOption),
        internal: users.filter(user => user.role <= Role.INTERNAL).map(toOption)
      };
    },
    enabled: Boolean(company),
    staleTime: 5 * 60 * 1000
  });
